<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="ordersreasons.icon" class="mr-1"></i>
                        <span>{{ ordersreasons.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">

                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Description" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="description" :debounce="ordersreasons.debounce"
                                            placeholder="Description"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!description"
                                                @click="description = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Code" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="code" :debounce="ordersreasons.debounce"
                                            placeholder="Code"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!code"
                                                @click="code = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Type" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="type" :debounce="ordersreasons.debounce"
                                            placeholder="Type"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!type"
                                                @click="type = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="ordersreasons" :icon="ordersreasons.icon"
                        :busy="ordersreasons.busy" :toolbarlibrary="ordersreasons.toolbarlibrary"
                        :tools="ordersreasons.tools" :badges="ordersreasons.badges" :fields="ordersreasons.fields"
                        :items="ordersreasons.items" :limit="ordersreasons.limit" :downloaded="ordersreasons.downloaded"
                        :showpages="true" :offset="ordersreasons.offset" :page="ordersreasons.page"
                        @load="ordersreasons_load" @click="ordersreasons_click"
                        @changed="ordersreasons_click('save', $event)" @select="ordersreasons_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="ordersreasons.selected" :config="cconfig"
                    @discard="ordersreasons_click('discard')" @go="ordersreasons_click('go')"></component>
            </div>
            <b-card-footer class="mt-2 ml-1">
                <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>
            </b-card-footer>

        </b-card>
    </div>
</template>

<script>
import gql from "graphql-tag";

import OrdersReasonsEdit from "./Components/Setup_OrdersReasonEdit";

export default {
    name: "OrdersReasons",
    components: { OrdersReasonsEdit },
    watch: {
        async description() {
            await this.ordersreasons_load(0);
        },
        async code() {
            await this.ordersreasons_load(0);
        },
        async type() {
            await this.ordersreasons_load(0);
        },
    },
    data() {
        return {
            description: null,
            code: null,
            type: null,

            ordersreasons: {
                title: "Order Reasons",
                icon: "fa fa-gavel",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,download,clipboard,add,edit,deleteconfirm",
                toolbarlibrary: [],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-50px",
                    },
                    {
                        key: "code",
                        label: "Code",
                        sortable: true,
                    },
                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                    },
                    {
                        key: "description",
                        label: "Description",
                        sortable: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "type",
                        type: "badge",
                        All: "success",
                        Hotels: "warning",
                        Orders: "danger",
                        formatter: (value, key, item) => {
                            switch (value) {
                                case null:
                                    return "All";
                                    break;
                                case "H":
                                    return "Hotels";
                                    break;
                                case "O":
                                    return "Orders";
                                    break;
                                default:
                                    return value;
                            }
                        },
                    },
                ],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();

        await this.ordersreasons_load();
    },

    methods: {
        accessdenied() {
            this.ordersreasons.denied = [];
            if (!this.user.permissions.includes("setup_ordersreasons.admin")) {
                this.ordersreasons.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("setup_ordersreasons.admin")) {
                this.ordersreasons.denied.push("add");
                this.ordersreasons.denied.push("save");
            }

        },


        async ordersreasons_load(offset, limit, page) {
            let state = this.ordersreasons;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,

                id: this.id,
                description: this.description,
                code: this.code,
                type: this.type,
                dateformat: "DD/MM/YYYY",
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                query setup_ordersreasons(
                  $limit: Int
                  $offset: Int
                  $description: String
                  $code: String
                  $type: String
                  $dateformat: String       
                ) {
                  setup_ordersreasons(
                    limit: $limit
                    offset: $offset
                    description: $description
                    code: $code
                    type: $type
                    dateformat: $dateformat
                  ) {
                    id
                    description
                    code
                    type      
                    rows
                    updated_at
                    updated_by
                  }
                }
              `,
                    variables,
                });

                // USE LOCAL VARIABLE             

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_ordersreasons
                } else {
                    state.items = response.data.setup_ordersreasons;
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async ordersreasons_click(a, ss) {

            let state = this.ordersreasons;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.ordersreasons_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.ordersreasons_load();
                    break;
                case "go":
                    this.component = null;
                    await this.ordersreasons_load();
                    break;
                case "add":
                case "edit":
                    this.component = "OrdersReasonsEdit";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;
            }
        },
        async ordersreasons_select(ss, tools) {

            let state = this.ordersreasons;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async saveit(ss) {

            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                mutation setup_ordersreasons_save(
                  $rows: [setup_ordersreasons_input]             
                ) {
                  setup_ordersreasons_save(rows: $rows) {
                    id
                    description
                    code
                    type      
                  }
                }
              `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                mutation setup_ordersreasons_delete(
                  $rows: [setup_ordersreasons_input]
                ) {
                  setup_ordersreasons_delete(rows: $rows) {
                    id
                  }
                }
              `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.ordersreasons_load(0);
        },
    },
};
</script>

<style scoped></style>